module.exports = __webpack_public_path__ + "static/media/icon_34.c76ec36e.svg";